import script from "./DocumentsRecived.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsRecived.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsRecived.vue?vue&type=style&index=0&id=638da8a3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638da8a3"]])

export default __exports__